import { gql } from '@apollo/client';

import { MEDIA_FRAGMENT } from './mediaFragment';

// Overview fragment for listing pages - only includes fields needed for the table

export const ORGANIZATION_OVERVIEW_FRAGMENT = gql`
  fragment OrganizationOverviewFields on Organization {
    id
    name
    code
    description
    mccCode
    createdAt
    users {
      id
    }
    status
  }
`;

// Full fragment for detail pages - includes all fields
export const ORGANIZATION_FRAGMENTS = gql`
  fragment OrganizationFields on Organization {
    id
    code
    name
    email
    description
    status
    mccCode
    licenseNumber
    type
    website
    industry
    otherIndustry
    refundPolicyTerms
    merchantProcessingFee
    address
    phoneNumber
    logo {
      ...MediaFields
    }
    createdAt
    updatedAt
  }
  ${MEDIA_FRAGMENT}
`;

export const ORGANIZATION_ME_FRAGMENT = gql`
  fragment OrganizationMeFields on Organization {
    id
    name
    description
    mccCode
    createdAt
  }
`;

// Overview fragment for the platform-admin bank listing page. Banks are
// organizations of type BANK; the list shows the channels they serve and
// their country, neither of which the merchant overview needs.
export const BANK_LIST_OVERVIEW_FRAGMENT = gql`
  fragment BankListOverviewFields on Organization {
    id
    name
    code
    email
    phoneNumber
    country
    status
    supportedChannels
    createdAt
    users {
      id
    }
  }
`;
